// MonthlyCalculationPanel.jsx — PC '1:1급여 정산' 탭 (2026-10-06 UX 3단계에서 다시 짬)
//   진행 상태 카드(ChargeStatusCard) + 직원 목록(ChargeList) | 직원 상세(ChargeReviewDetail) + 확정 요약 창.
//   불러오기·넣기/빼기·확정은 페이지가 만든 useMonthlyCalculation(calc)을 받아 쓴다(휴대폰 화면과 공유).
import React, { useRef, useState } from 'react';
import { ChargeStatusCard } from './ChargeStatusCard';
import { ChargeList, filterRows } from './ChargeList';
import { ChargeReviewDetail } from './ChargeReviewDetail';
import { ChargeConfirmDialog } from './ChargeConfirmDialog';
import { C } from './charge.styles';

export function MonthlyCalculationPanel({ calc, integratedMenuId = null, onOpenRules }) {
  const [filter, setFilter] = useState('all');
  const [confirmOpen, setConfirmOpen] = useState(false);
  const detailRef = useRef(null);
  const selectedId = calc.selectedRow?.assignmentId ?? null;

  // 목록을 내려 본 상태에서 직원을 고르면 상세 머리가 보이게 올린다
  function select(id) {
    calc.handleSelectRow(id);
    const el = detailRef.current;
    if (el && el.getBoundingClientRect().top < 0) el.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }

  function cleanup() {
    setFilter('pending');
    const first = filterRows(calc.rows, 'pending')[0];
    if (first) select(first.assignmentId);
  }

  function requestConfirm() {
    if (calc.canConfirm()) setConfirmOpen(true);
  }

  return (
    <section style={C.card}>
      <ChargeStatusCard calc={calc} onCleanup={cleanup} onRequestConfirm={requestConfirm} />
      {calc.error && !confirmOpen && <div style={{ padding: '12px 12px 0' }}><div style={C.error}>{calc.error}</div></div>}
      <div style={C.workspace}>
        <ChargeList
          rows={calc.rows}
          filter={filter}
          onFilter={setFilter}
          selectedId={selectedId}
          onSelect={select}
          loading={calc.loading}
        />
        <div ref={detailRef} style={{ minWidth: 0, scrollMarginTop: 12 }}>
          <ChargeReviewDetail
            calc={calc}
            row={calc.selectedRow}
            assignment={calc.selectedAssignment}
            rows={calc.rows}
            onSelect={select}
            onOpenRules={onOpenRules}
            integratedMenuId={integratedMenuId}
          />
        </div>
      </div>
      <ChargeConfirmDialog open={confirmOpen} calc={calc} onClose={() => setConfirmOpen(false)} />
    </section>
  );
}
